<template>
  <div>
    <Yukleniyor :data="lo"></Yukleniyor>
    <el-table
      class="table-xs"
      style="width: 100%"
      width="100%"
      :data="Liste"
      v-if="data"
      row-key="id"
      :height="Height"
      show-summary
      :summary-method="TableFooter">
      <el-table-column
        prop="HesapAdi"
        label="Hesap">
      </el-table-column>
      <el-table-column
        prop="Tahsil"
        label="Tutar"
        align="right"
        width="100">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import Yukleniyor from "../../../components/Doc/Yukleniyor";

  export default {
    components: {Yukleniyor},
    data() {
      return {
        lo: true,
        Liste: null,
        AltToplam: 0,
        data: null,
        Height: window.innerHeight - 195

      }
    },
    methods: {
      TableFooter() {
        const sums = [];
        sums[1] = this.AltToplam;
        return sums;
      },
      SayfaYukle() {
        this.$store.dispatch("Get", {path: '_a/p/aibasarili'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste;
              this.AltToplam = response.AltToplam;
              this.lo = false;
              if (this.Liste) this.data = true;
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
      },
    },
    created() {
      this.SayfaYukle();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/_a/comp/aiBugunBasariliPos.vue